import dayjs, { Dayjs } from 'dayjs';
import { useContext } from "react";
import { getListMeasurements } from "../../service/PlantsService";

const dateFormat: string = 'YYYY-MM-DD';

function convertToCSV(data: any) {
  let csvContent = "user_plant_id,light,temperature,soil_moisture,soil_fertility,date_utc\n";

  data.user_plants.forEach((userPlant: { measurements: any[]; user_plant_id: any; }) => {
    userPlant.measurements.forEach(measurement => {
        // Construct a CSV row
        let row = [
            userPlant.user_plant_id,
            measurement.light,
            measurement.temperature,
            measurement.soil_moisture,
            measurement.soil_fertility,
            measurement.date_utc
        ].join(",");
        csvContent += row + "\n";
    });
});

return csvContent;

}

function downloadFile(data: string, fileName: string, fileType: string) {
  const blob = new Blob([data], { type: fileType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
}

function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function handleExport(authToken: string, format: string, dateRange: [Dayjs, Dayjs], plant: number[]) {

  const startDate = dateRange[0].format(dateFormat);
  const endDate = dateRange[1].format(dateFormat);

  const chunkSize = 10;
  const chunkedArray = [];

  for (let i = 0; i < plant.length; i += chunkSize) {
    chunkedArray.push(plant.slice(i, i + chunkSize));
  }

  const responses = await Promise.all(
    chunkedArray.map(async (chunk, index) => {
      if (index > 0) {
        await sleep(500 * index);  // Introduce a delay of 500ms * index
      }
      const response = await getListMeasurements(authToken, chunk, startDate, endDate);
      console.log('response', response)
      return response.user_plants;
    })
  );
  console.log('responses', responses)

  // const responses = [];
  // for (let i = 0; i < chunkedArray.length; i++) {
  //   const chunk = chunkedArray[i];
  //   try {
  //     const response = await getListMeasurements(authToken, chunk, startDate, endDate);
  //     console.log('response', response)
  //     responses.push(response.user_plants);
  //   } catch (error) {
  //     console.error('Error fetching plants for chunk:', chunk, error);
  //   }
  //
  //   // Add a 500ms delay before making the next request
  //   if (i < chunkedArray.length - 1) {
  //     await sleep(500);
  //   }
  // }
  // console.log('responses', responses)

  const data = {user_plants: responses.flat()};
  console.log('data', data)

  // const data = await getListMeasurements(authToken, plant, startDate, endDate);

  if (!data) return;

  if (format === 'csv') {
    const csvData = convertToCSV(data);
    downloadFile(csvData, 'data.csv', 'text/csv');
  } else if (format === 'json') {
    const jsonData = JSON.stringify(data, null, 2);
    downloadFile(jsonData, 'data.json', 'application/json');
  }

}
